<template>
    <div class="offers" v-if="isMounted" v-can="'settings_offer.access'">
        <ds-filter
            :data="offers"
            :fields="filterFields"
            @resultFilter="resultFilter"
            @updateFilterFields="updateFilterFields"
        ></ds-filter>

        <ds-table
            ref="table"
            :data="offersListFilter"
            :heads="heads"
            expand
            search
        >
            <template v-slot:header>
                <vs-button
                    v-can="'settings_offer.create'"
                    @click="addOffer()"
                    class="mr-4 whitespace-no-wrap"
                    color="primary"
                    type="border"
                    v-bind="$iconData('icon-plus', 'fi-rr-plus')"
                >
                    {{ $t('modals.Add_offer') }}
                </vs-button>
            </template>

            <template v-slot:landings="{landings}">
                <vs-chip v-tooltip="landings.landingsList.join('<br>')">
                    <vs-avatar color="#f0f0f0" text-color="#175ea5" v-bind="$iconData('icon-hard-drive', 'fi-rr-hdd')"></vs-avatar>
                    <span>{{ landings.landingsLength }}</span>
                </vs-chip>
            </template>

            <template v-slot:status="{status}">
                <vs-switch v-can="'settings_offer.destroy'" color="success"
                           @click.stop.prevent="changeOffersStatus($event, status)"
                           :checked="Boolean(status.is_active)" icon-pack="feather" vs-icon-off="icon-x"
                           vs-icon-on="icon-check"/>
                <vs-switch v-can:show="'settings_offer.destroy'" color="success" disabled icon-pack="feather"
                           vs-icon-off="icon-x" vs-icon-on="icon-check"/>
            </template>

            <template v-slot:actions="{actions}">
                <vs-button v-can="'settings_offer.destroy'" @click.stop.prevent="editOffer(actions)" radius
                           color="primary" type="flat"
                           v-bind="$iconData('icon-edit', 'fi-rr-file-edit')"
                           v-tooltip="$t('modals.Edit_offer')"></vs-button>
                <vs-button v-can:show="'settings_offer.destroy'" disabled radius color="primary" type="flat"
                           v-bind="$iconData('icon-edit', 'fi-rr-file-edit')"></vs-button>
            </template>

            <template v-slot:expand="{expand}">
                <OffersListDetails :data="expand"/>
            </template>
        </ds-table>
    </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import OffersListDetails from './OffersListDetails'
import EventBus from '@/store/eventBus'
import ErrorHandler from '@/utils/errorHandler'

export default {
    name: 'OffersList',

    components: {
        OffersListDetails
    },

    data() {
        return {
            isMounted: false,
            currentOffer: null,
            loadingEl: null,
            offersListFilter: [],
            filterFields: [
                {name: 'settings.Offer_status', type: 'select', label: 'active_name', field: 'active_name'},
                {name: 'modals.Choose_landing', key: 'landings', type: 'select', label: 'full_name', field: 'id', sortKey: 'value'}
            ],
            heads: [
                {name: 'global.Name', key: 'name', sortKey: 'name', value: 'name', display: true},
                {name: 'global.Landings', key: 'landings', sortKey: 'landingsLength', value: 'landings', display: true},
                {name: 'global.Status', key: 'status', sortKey: 'is_active', value: 'status', display: true},
                {name: 'global.Actions', key: 'actions', value: 'actions', display: true},
            ]
        }
    },

    computed: {
        ...mapGetters(['offers', 'filterOffers'])
    },

    methods: {
        ...mapActions(['GET_OFFER_LIST', 'UPDATE_STATUS']),

        resultFilter(data) {
            this.offersListFilter = data
        },

        updateFilterFields() {
            this.$refs.table.closeExpands()
        },

        addOffer() {
            EventBus.$emit('emitPopupEvent', {
                type: 'addOffer',
                name: this.$t('modals.Add_offer'),
                data: {}
            })
        },

        editOffer(data) {
            EventBus.$emit('emitPopupEvent', {
                type: 'editOffer',
                name: this.$t('modals.Edit_offer'),
                data: data
            })
        },

        changeOffersStatus(e, data) {
            this.currentOffer = data.id

            this.loadingEl = e.target.parentNode
            this.$vs.dialog({
                type: 'confirm',
                color: 'warning',
                title: this.$t('confirm.Confirm_action'),
                text: data.is_active ? this.$t('confirm.deactivateOffer') : this.$t('confirm.activateOffer'),
                accept: this.sendStatus,
                acceptText: data.is_active ? this.$t('buttons.Deactivate') : this.$t('buttons.Activate'),
                cancelText: this.$t('global.Cancel')
            })
        },

        async sendStatus() {
            this.$vs.loading({
                background: 'rgba(255,255,255,0.75)',
                color: 'primary',
                container: this.loadingEl,
                scale: +'0.45'
            })
            try {
                await this.UPDATE_STATUS({id: this.currentOffer})
                this.$vs.loading.close(this.loadingEl)
            } catch (e) {
                new ErrorHandler(e).send
            }
        }
    },

    async mounted() {
        try {
            await this.GET_OFFER_LIST()
            this.isMounted = true
        } catch (e) {
            new ErrorHandler(e).send
        }
    },

    destroyed() {
        this.$store.commit('SET_LIST', [])
    }
}
</script>
